import {Component, OnInit} from '@angular/core';
import {NotificationService} from '../../../../services/notification.service';
import {TaskService} from '../../../../services/task.service';
import {TaskOverviewDTO} from '../../../../model/taskOverviewDTO';
import {Router} from '@angular/router';

@Component({
  templateUrl: './task-overview.component.html',
})
export class TaskOverviewComponent implements OnInit {

  content: TaskOverviewDTO[] = [];

  constructor(private service: TaskService,
              private router: Router,
              private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.getPage();
  }

  getPage() {
    this.service.getOverview().subscribe(data => this.content = data);
  }

  navigate(row: TaskOverviewDTO) {
    this.router.navigate([`bewind/${row.clientId}`]);
  }
}
